import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetAdjustment  {
    _originalTypeClassName = "zERP.BO.BudgetAdjustment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetAdjustment.translate = translateService;
}
this.Modifications = [];
this.Budget = new Domain.Budget();
this.BusinessEntity = new Domain.BusinessEntity();
this.FileUploads = [];
this.Id = null;
this.Description = null;
this.DateCreated = null;
this.DateSubmited = null;
this.SystemDateApproved = null;
this.Status = null;
this.ExpensesAmount = null;
this.IncomeAmount = null;
this.DateApproved = null;
this.ApprovalReference = null;
this.Number = null;
this.DateIssued = null;
this.ProtocolNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Description:any;
DateCreated:any;
DateSubmited:any;
SystemDateApproved:any;
Status:any;
ExpensesAmount:any;
IncomeAmount:any;
DateApproved:any;
ApprovalReference:any;
Number:any;
DateIssued:any;
ProtocolNumber:any;
CreatedBy:any;
Modifications:any;
ApprovedBy:any;
IssuedBy:any;
Budget:any;
FiscalYear:any;
BusinessEntity:any;
FileUploads:any;
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setModifications = ($this, items) => {
                if (items == null) items = [];
                if ($this.Modifications == null) $this.Modifications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Modifications.length > 0) {
                    Domain.BudgetAdjustment.removeModifications($this, $this.Modifications[0]);
                }

                Domain.BudgetAdjustment.addManyModifications($this, copyItems);
            }
static addManyModifications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetAdjustment.addModifications($this, items[i]);
                }
            }
static addModifications = ($this, item) => {
                if ($this.Modifications == null) $this.Modifications = [];
                if (item == null || $this.Modifications.indexOf(item) > -1) return;
                $this.Modifications.push(item);
if (item.Modification != $this) {
Domain.BudgetAdjustmentDetail.setModification(item, $this);
}
}
static addRangeModifications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetAdjustment.addModifications($this, item));
            }
static removeModifications = ($this, item) => {
                if ($this == null || $this.Modifications == null || $this.Modifications.indexOf(item) === -1) return;
                var _index = $this.Modifications.indexOf(item);
                $this.Modifications.splice(_index, 1);
item.Modification = null;
}
static clearModifications = ($this) => { $this.Modifications = null; }
static setApprovedBy = ($this, value) => {
var oldValue = $this.ApprovedBy;
$this.ApprovedBy = value;
if (value != null) {
}
}
static setIssuedBy = ($this, value) => {
var oldValue = $this.IssuedBy;
$this.IssuedBy = value;
if (value != null) {
}
}
static setBudget = ($this, value) => {
var oldValue = $this.Budget;
$this.Budget = value;
if (value != null) {
if (oldValue != null) {
Domain.Budget.removeModifications(oldValue, $this);
}
Domain.Budget.addModifications(value, $this);
}
}
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}
static setBusinessEntity = ($this, value) => {
var oldValue = $this.BusinessEntity;
$this.BusinessEntity = value;
if (value != null) {
}
}
static setFileUploads = ($this, items) => {
                if (items == null) items = [];
                if ($this.FileUploads == null) $this.FileUploads = [];

                const copyItems = Common.cloneObject(items);

                while ($this.FileUploads.length > 0) {
                    Domain.BudgetAdjustment.removeFileUploads($this, $this.FileUploads[0]);
                }

                Domain.BudgetAdjustment.addManyFileUploads($this, copyItems);
            }
static addManyFileUploads = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetAdjustment.addFileUploads($this, items[i]);
                }
            }
static addFileUploads = ($this, item) => {
                if ($this.FileUploads == null) $this.FileUploads = [];
                if (item == null || $this.FileUploads.indexOf(item) > -1) return;
                $this.FileUploads.push(item);
}
static addRangeFileUploads = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetAdjustment.addFileUploads($this, item));
            }
static removeFileUploads = ($this, item) => {
                if ($this == null || $this.FileUploads == null || $this.FileUploads.indexOf(item) === -1) return;
                var _index = $this.FileUploads.indexOf(item);
                $this.FileUploads.splice(_index, 1);
}
static clearFileUploads = ($this) => { $this.FileUploads = null; }

static UpdateTotals($this: any): any{let expenses = $this?.Modifications?.linq?.where((s) => (s?.BudgetDetail != null && s?.BudgetDetail?.BudgetItem?.Category?.IsExpense) || (s?.BudgetItem != null && s?.BudgetItem?.Category?.IsExpense))?.toArray();
let income = $this?.Modifications?.linq?.where((s) => (s?.BudgetDetail != null && !(s?.BudgetDetail?.BudgetItem?.Category?.IsExpense)) || (s?.BudgetItem != null && !(s?.BudgetItem?.Category?.IsExpense)))?.toArray();
$this.ExpensesAmount = (!(expenses?.linq?.any()) ? 0 : expenses?.linq?.sum((s) => s?.Amount));
$this.IncomeAmount = (!(income?.linq?.any()) ? 0 : income?.linq?.sum((s) => s?.Amount));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}